import { useEffect, useRef } from 'react';
import { aplicarTema } from './tema';

/** Até 2 iniciais do nome da incorporadora (ex.: "Costa Verde" → "CV"). */
function iniciaisOrg(nome?: string): string {
  const p = (nome ?? '').trim().split(/\s+/).filter(Boolean);
  const s = p.length >= 2 ? p[0]![0]! + p[1]![0]! : (p[0] ?? 'A').slice(0, 2);
  return s.toUpperCase();
}

/**
 * Casco visual das telas DESLOGADAS do comprador (login/entrar) —
 * deliberadamente separado do Shell.tsx do operador. Card centralizado,
 * mobile-first, já com a cor white-label da incorporadora (--brand) quando
 * conhecida. As telas logadas usam AppShellComprador (com a navegação).
 */
export function CompradorShell({
  children,
  logoUrl,
  orgNome,
  corMarca,
}: {
  children: React.ReactNode;
  logoUrl?: string | null;
  orgNome?: string;
  corMarca?: string | null;
}) {
  const raiz = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (raiz.current) aplicarTema(raiz.current, corMarca ?? null);
  }, [corMarca]);

  return (
    <div ref={raiz} className="flex min-h-dvh items-center justify-center bg-bg-warm px-6 py-12">
      <div className="w-full max-w-[360px]">
        {/* Marca: tile arredondado na cor da incorporadora + nome (design oficial).
            Sem card em volta do conteúdo — tudo direto sobre o fundo. */}
        <div className="mb-8 flex flex-col items-center text-center">
          <div
            className="mb-3 flex h-[68px] w-[68px] items-center justify-center overflow-hidden rounded-[20px]"
            style={{ background: 'var(--brand, var(--accent))' }}
            aria-hidden="true"
          >
            {logoUrl ? (
              <img src={logoUrl} alt={orgNome ?? 'Logo'} className="h-full w-full object-contain p-2.5" />
            ) : (
              <span className="font-serif text-2xl font-semibold text-white">{iniciaisOrg(orgNome)}</span>
            )}
          </div>
          {orgNome && <div className="text-sm text-ink-3">{orgNome}</div>}
        </div>
        {children}
      </div>
    </div>
  );
}
